module.exports = __webpack_public_path__ + "static/img/2_1_4_2.669b4800.jpg";